const en = {
  title: 'Thank you for your contribution!',
  buttonLabel: `Done`,
};

export default en;
